import styled, { css } from 'styled-components';
import { withLayout } from '@rsos/components/capstone/base/Layout';
import { breakpoints } from '@rsos/constants';
import { UNITE_EVENT_PANE_WIDTH } from '../../constants/dataComponentsDimensions';

const { BP_LAPTOP, BP_TABLET } = breakpoints;

const MapContainer = withLayout(styled.div`
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;
  overflow-x: hidden; // prevent over extending the map when info window displays outside of the view port
  ${({ isIRP, selectedItem, hasW3wToRender }) =>
    !isIRP && (selectedItem || hasW3wToRender)
      ? css`
          @media (max-width: ${BP_LAPTOP}px) {
            width: 100%;
            height: ${selectedItem
              ? '455px'
              : '100%'}; // set height if there is a selectedItem and the map is on top, otherwise it should fill in the remaining space
          }
          @media (max-width: ${BP_TABLET}px) {
            height: ${selectedItem ? '465px' : '100%'};
          }
        `
      : null}

  ${({ isIRP }) =>
    isIRP &&
    css`
      @media (max-width: ${BP_LAPTOP}px) {
        display: none;
      }
    `}
  ${({ isEventPaneCollapsed }) => {
    if (isEventPaneCollapsed) {
      // When the Event Pane is collapsed it has position:fixed. Adding a margin here ensures that the ESRI UI elements are not hidden behind it.
      return css`
        .esri-ui-top-left {
          margin-left: ${UNITE_EVENT_PANE_WIDTH}px;
        }
      `;
    }
  }}
`);

export default MapContainer;
